import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import StatusChartPanel from './StatusChartPanel';
import { entityType } from '../../filters/agent-filter/AgentFilter';
import { agentFilterId, businessServiceFilterId, testTypeFilterId, timeRangeFilterId } from '../../filters';

const title = t`nPoint Status`;

function AgentStatusPanel() {
    return <StatusChartPanel entityType={entityType} />;
}

AgentStatusPanel.propTypes = {
    ...panelPropTypes,
};

AgentStatusPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 40,
    minContentHeight: 40,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'AgentStatusTrend',
    catalogEntry: {
        category: PANEL_CATEGORIES.AGENT,
        priority: PANEL_PRIORITIES.STATUS,
        title,
        description: t`Status trend for a selected nPoint`,
        previewImage: STATUS_CHART_PANEL_PREVIEW_IMAGE,
    },
    filters: {
        required: [timeRangeFilterId, agentFilterId],
        optional: [businessServiceFilterId, testTypeFilterId],
    },
})(AgentStatusPanel);
